var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Mark Shipment TAT Breach ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("AWB Number :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumber),
      expression: "awbnumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "awbnumber",
      "name": "awbnumber",
      "type": "text"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Action:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('div', {
    on: {
      "change": function($event) {
        _vm.selectOption($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.takeActionname),
      expression: "takeActionname"
    }],
    attrs: {
      "type": "radio",
      "name": "Forcefully Lost",
      "value": "15"
    },
    domProps: {
      "checked": _vm._q(_vm.takeActionname, "15")
    },
    on: {
      "__c": function($event) {
        _vm.takeActionname = "15"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Forcefully Lost"
    }
  }, [_vm._v("Forcefully Lost ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Destination :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "dropStatus",
      "disabled": _vm.actionCondition !== 1,
      "options": _vm.finalhublist,
      "placeholder": "Destination",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.finalhublist),
      callback: function($$v) {
        _vm.finalhublist = $$v
      },
      expression: "finalhublist"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Status')),
      expression: "errors.has('Status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Required. ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("REC Reasons :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "recreasons",
      "disabled": _vm.RecReasonDisable,
      "options": _vm.RecList,
      "placeholder": "Rec Reasons",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.recreasons),
      callback: function($$v) {
        _vm.recreasons = $$v
      },
      expression: "recreasons"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Description :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Submit")]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    staticStyle: {
      "background-color": "transparent",
      "margin": "-8px",
      "width": "20%"
    },
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.loading
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('p', {
    staticClass: "counts"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Failed: " + _vm._s(_vm.recFailed.length ? _vm.recFailed.length : 0) + " ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" Suceess: " + _vm._s(_vm.recSuccess.length ? _vm.recSuccess.length : 0) + " ")]), _vm._v(" "), _c('span', [_vm._v("Total: " + _vm._s(_vm.AWBLength))])]), _vm._v(" "), _c('div', {
    staticClass: "resultTables"
  }, [(_vm.recFailed.length > 0) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Error Message")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.recFailed), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.shippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.message))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.recSuccess.length > 0) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Response Message")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.recSuccess), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.shippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.message))])])
  }))]) : _vm._e()])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF0000"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21833182","hasScoped":true}!./src/views/components/Rec/Rec.component.html
// module id = 693
// module chunks = 1